module.exports = __webpack_public_path__ + "static/media/python-expert.2fd9ebe4.png";